












import Vue from 'vue';
import AppTitle from '@/components/common/AppTitle/AppTitle.vue';
import { mapActions } from 'vuex';

export default Vue.extend({
  name: 'AppDrawerHeader',
  components: {
    AppTitle,
  },
  methods: {
    ...mapActions('global', ['toggleDrawer']),
  },
});
